<template>
    <div class="filter">
        <div class="ui form" @keypress.enter="$parent.core_waybills_filter()">
            <div class="ui list">
                <div class="item">
                    <i class="barcode big icon pointer"
                        @click="is_show_numbers = !is_show_numbers">
                    </i>
                    <div class="content">
                        <div class="header pointer">
                            <h3 @click="is_show_numbers = !is_show_numbers"  style="z-index: 2;">
                                {{ $t('ui.pages.core_waybills.filter.numbers') }}
                                <i class="icon"
                                    style="margin: 0;"
                                    :class="{
                                        'caret down': !is_show_numbers,
                                        'caret up': is_show_numbers,
                                    }"
                                ></i>
                            </h3>
                        </div>
                        <transition name="slide-fade" mode="out-in">
                            <div v-show="is_show_numbers">
                            <div class="filter_border"></div>
                            <div class="two fields">
                                <div class="field">
                                    <label>{{ $t('models.attributes.core_waybills.number') }}</label>
                                    <input type="text"
                                        v-model="filter.number"
                                    >
                                </div>
                                <div class="field">
                                    <label>{{ $t('models.attributes.core_waybills.operation_number') }}</label>
                                    <input type="text"
                                        v-if="!$route.params.operation_number"
                                        v-model="filter.operation.number"
                                    >
                                    <div
                                        class="ui segment"
                                        style="margin: 0; padding: 9px 12px;"
                                        v-else>
                                        {{ $route.params.operation_number }}
                                    </div>
                                </div>
                            </div>
                            <div class="two fields">
                                <div class="field">
                                    <label>{{ $t('models.attributes.core_waybills.original_number') }}</label>
                                    <input type="text"
                                        v-model="filter.original_number"
                                    >
                                </div>
                                <div class="field">
                                    <label>{{ $t('models.attributes.core_waybills.tracking_number') }}</label>
                                    <input type="text"
                                        v-model="filter.tracking_number"
                                    >
                                </div>
                            </div>
                        </div>
                        </transition>
                    </div>
                </div>

                <div class="item">
                    <i class="file alternate big icon pointer"
                        @click="is_show_info = !is_show_info">
                    </i>
                    <div class="content">
                        <div class="header pointer">
                            <h3 @click="is_show_info = !is_show_info">
                                <!-- 運單資訊 -->
                                {{ $t('ui.pages.core_waybills.filter.waybill_content') }}
                                <i class="icon"
                                    style="margin: 0;"
                                    :class="{
                                        'caret down': !is_show_info,
                                        'caret up': is_show_info,
                                    }"
                                ></i>
                            </h3>
                        </div>
                        <transition name="slide-fade" mode="out-in">
                            <div v-show="is_show_info">
                            <div class="filter_border"></div>
                            <div class="two fields">
                                <div class="field blue">
                                    <label>{{ $t('models.attributes.core_waybills.consignee_name') }}</label>
                                    <input type="text"
                                        v-model="filter.consignee_name"
                                    >
                                </div>
                                <div class="field blue">
                                    <label>{{ $t('models.attributes.core_waybills.consignee_address') }}</label>
                                    <input type="text"
                                        v-model="filter.consignee_address"
                                    >
                                </div>
                            </div>
                            <div class="three fields">
                                <div class="field blue">
                                    <label>{{ $t('models.attributes.core_waybills.consignee_phone') }}</label>
                                    <input type="text"
                                        v-model="filter.consignee_phone"
                                    >
                                </div>
                                <div class="field">
                                    <label>{{ $t('models.attributes.core_waybills.note') }}</label>
                                    <input type="text"
                                        v-model="filter.note"
                                    >
                                </div>
                                <div class="field">
                                    <label>{{ $t('ui.pages.core_waybills.filter.is_used.true') }}</label>
                                    <div v-dropdown
                                        @change="$forceUpdate()"
                                        class="ui selection dropdown"
                                    >
                                        <div class="text"
                                            v-for="filter_is_used_selections in filter_is_used_selections"
                                            v-if="filter_is_used_selections.boolean == filter.is_used">
                                            {{ filter_is_used_selections.name }}
                                        </div>

                                        <i class="dropdown icon"></i>
                                        <div class="menu">
                                            <div
                                                v-for="filter_is_used_selection in filter_is_used_selections"
                                                @click="filter.is_used = filter_is_used_selection.boolean"
                                                class="item"
                                                :class="{
                                                    'selected active': filter.is_used == filter_is_used_selection.boolean
                                                }">
                                                {{ filter_is_used_selection.name }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="three fields">
                                <div class="field">
                                    <label>{{ $t('models.attributes.core_waybills.created_at') }}</label>
                                    <DatePicker
                                        v-model="filter.created_duration"
                                        :re_init="Boolean(filter.created_duration)"
                                        style="width: 100%;"
                                        type="daterange"
                                        format="YYYY-MM-DD"
                                        key="core_waybills_created_duration">
                                    </DatePicker>
                                    <!-- <el-date-picker
                                        style="width: 100%;"
                                        v-model="filter.created_duration"
                                        unlink-panels
                                        type="daterange"
                                        align="center"
                                        :start-placeholder="$t('ui.el.datepicker.startDate')"
                                        :end-placeholder="$t('ui.el.datepicker.endDate')"
                                        :picker-options="$store.state.element_ui_datepicker_daterange_options"
                                        >
                                    </el-date-picker> -->
                                </div>
                                <div class="field">
                                    <label>{{ $t('models.attributes.core_waybills.shipping_date') }}</label>
                                    <DatePicker
                                        v-model="filter.shipping_date_duration"
                                        :re_init="Boolean(filter.shipping_date_duration)"
                                        style="width: 100%;"
                                        type="daterange"
                                        format="YYYY-MM-DD"
                                        key="core_waybills_shipping_date_duration">
                                    </DatePicker>
                                </div>
                                <div class="field">
                                    <label>{{ $t('ui.pages.core_waybills.filter.clearance_date') }}</label>
                                    <DatePicker
                                        v-model="filter.status.created_duration"
                                        :re_init="Boolean(filter.status.created_duration)"
                                        style="width: 100%;"
                                        type="daterange"
                                        format="YYYY-MM-DD"
                                        key="core_waybills_status_created_duration">
                                    </DatePicker>
                                    <!-- <el-date-picker
                                        style="width: 100%;"
                                        v-model="filter.status.created_duration"
                                        unlink-panels
                                        type="daterange"
                                        align="center"
                                        :start-placeholder="$t('ui.el.datepicker.startDate')"
                                        :end-placeholder="$t('ui.el.datepicker.endDate')"
                                        :picker-options="$store.state.element_ui_datepicker_daterange_options"
                                        >
                                    </el-date-picker> -->
                                </div>
                            </div>
                        </div>
                        </transition>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from "@toolbox/date_picker/main.vue"

export default {
    props: {
    },
    data() {
        return {
            is_show_numbers: true,
            is_show_info: true,
            is_initialized: false,
            is_processing: false,
            filter_is_used_selections: [
                // {name: '請選擇狀態', boolean: null},
                // {name: '未使用', boolean: 'false'},
                // {name: '已使用', boolean: 'true'},
                {name: this.$t('ui.pages.core_waybills.filter.selected_is_used'), boolean: null},
                {name: this.$t('ui.pages.core_waybills.filter.is_used.flase'), boolean: 'false'},
                {name: this.$t('ui.pages.core_waybills.filter.is_used.true'), boolean: 'true'},
            ],
        }
    },
    computed: {
        current_store() {
            return this.$store.state.customer.core_waybills_module
        },
        filter() {
            return this.current_store.filter
        },
    },
    created() {
    },
    mounted() {
        this.init()
    },
    watch: {
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                let query = this.$store.getters['customer/core_waybills_module/filter_to_query']
                if (Object.keys(query).length) {
                    if (
                        !this.filter.number &&
                        !this.filter.operation.number &&
                        !this.filter.original_number &&
                        !this.filter.tracking_number
                    ) {
                        this.is_show_numbers = false
                    }
                }
                resolve()
            })
            await new Promise(resolve => {
                this.is_initialized = true
                resolve()
            })
        },
    },
    components: {
        DatePicker
    },
}
</script>
<style>
.el-date-editor.el-range-editor input {
    border: none !important;
}
</style>
<style scoped lang="scss">
    .filter_border {
        border: 0.5px #666 solid;
        margin: 12px 0;
    }
    .ui.list .item {
        & {
            padding-bottom: 9px;
        }
        .content {
            & {
                width: 100%;
            }
            .header {
                margin-bottom: 6px;
            }
        }
    }

    .ui.form .field {
        &.red input {
            border-top: 2px solid #db2828!important;
        }
        &.orange input {
            border-top: 2px solid #f2711c!important;
        }
        &.olive input {
            border-top: 2px solid #b5cc18!important;
        }
        &.green input {
            border-top: 2px solid #21ba45!important;
        }
        &.teal input {
            border-top: 2px solid #00b5ad!important;
        }
        &.blue input {
            border-top: 2px solid #2185d0!important;
        }
        &.violet input {
            border-top: 2px solid #6435c9!important;
        }
        &.purple input {
            border-top: 2px solid #a333c8!important;
        }
        &.grey input {
            border-top: 2px solid #767676!important;
        }
    }
</style>
